import { Fragment, memo } from "react";
import { Typography } from "antd";
import {
  ProjectOutlined,
  LineChartOutlined,
  TeamOutlined,
  FileTextOutlined,
  SafetyOutlined,
  PieChartOutlined,
} from "@ant-design/icons";
import { LOGIN_BRAND, LOGIN_FEATURES } from "../login.constants";

const { Title, Text } = Typography;

const FEATURE_ICONS= {
  governance: <SafetyOutlined />,
  tracking: <LineChartOutlined />,
  resource: <TeamOutlined />,
  billing: <FileTextOutlined />,
  dashboards: <PieChartOutlined />,
};

const FEATURES= LOGIN_FEATURES.map((feature) => ({
  ...feature,
  icon: FEATURE_ICONS[feature.key],
}));

function LoginHeroComponent() {
  return (
    <div className="login-page__hero">
      <div className="login-page__logo">
        <ProjectOutlined style={{ fontSize: 24, color: "white" }} />
      </div>
      <Title level={2} className="login-page__title">
        {LOGIN_BRAND.title}
      </Title>
      <Text className="login-page__subtitle">{LOGIN_BRAND.subtitle}</Text>

      <div className="login-page__features">
        {FEATURES.map((feature, index) => (
          <Fragment key={feature.key}>
            <div className="login-page__feature">
              <div className="login-page__feature-icon">{feature.icon}</div>
              <Text className="login-page__feature-label">{feature.label}</Text>
            </div>

            {index < FEATURES.length - 1 && (
              <div className="login-page__feature-divider">|</div>
            )}
          </Fragment>
        ))}
      </div>
    </div>
  );
}

export const LoginHero = memo(LoginHeroComponent);
